<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>财务管理</el-breadcrumb-item>
      <el-breadcrumb-item>公司明细账</el-breadcrumb-item>
    </el-breadcrumb>
    <el-button size="mini"
               @click="toNewUserCostPage">新建公司明细账</el-button>
    <br>
    <el-date-picker
      v-model="areaExpendRequest.selectDay"
      type="daterange"
      range-separator="至"
      size="mini"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      @change="selectReportDataDay"
      value-format="yyyy-MM-dd"
    >
    </el-date-picker>
    <el-select v-model="selectOrgId" v-if="orgLevel == 1" clearable value filterable placeholder="请选择门店"
               style="margin-left: 5px;width: 200px" size="mini" @change="getShop">
      <el-option
        v-for="org in orgList"
        :key="org.id"
        :label="org.label"
        :value="org.id">
      </el-option>
    </el-select>
    <el-select v-model="areaExpendRequest.expendType" clearable value filterable placeholder="请选择花销类型"
               style="margin-left: 5px;width: 200px" size="mini" @change="getAreaExpendType">
      <el-option
        v-for="orgCost in dataTypes"
        :key="orgCost.id"
        :label="orgCost.label"
        :value="orgCost.id">
      </el-option>
    </el-select>
    <el-button size="mini" style="margin-left: 5px;" @click="loadAreaExpendList">查询</el-button>
    <el-table height="550px" :data="areaExpends" fit border stripe="stripe" :header-cell-style="{background:'#eff3f8', color:'#333'}"
              :row-style="{height: '0'}"
              show-summary>
      <el-table-column
        align="center"
        label="操作" width="100"
      >
        <template slot-scope="scope">
          <div style="display: flex;justify-content: space-evenly">
            <el-link icon="el-icon-edit" size="mini"
                     type="primary"  @click="showUpdateCostDialog(scope.row)"
            ></el-link>
            <el-link type="primary" icon="el-icon-delete"
                     @click="deleteAreaExpend(scope.row)"></el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="expendDate"
        width="120"
        label="日期">
      </el-table-column>
      <el-table-column
        align="center"
        prop="orgName"
        width="140"
        label="机构">
      </el-table-column>
      <el-table-column
        align="center"
        prop="expendTypeName"
        label="花销类型">
      </el-table-column>
      <el-table-column
        align="center"
        prop="money"
        label="金额">
      </el-table-column>
      <el-table-column
        align="center"
        prop="szType"
        :formatter="szFormatter"
        label="收支类型">
      </el-table-column>
      <el-table-column
        align="center"
        label="摘要">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <p>{{ scope.row.expendTitle }}</p>
            <div slot="reference" class="name-wrapper">
              <el-tag size="mini">{{ scope.row.expendTitle }}</el-tag>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="comment"
        label="备注">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <p>{{ scope.row.comment }}</p>
            <div slot="reference" class="name-wrapper">
              <el-tag size="mini">{{ scope.row.comment }}</el-tag>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="createName"
        label="创建人">
      </el-table-column>
      <el-table-column
        align="center"
        prop="createTime"
        label="创建时间" width="200">
      </el-table-column>
      <el-table-column
        align="center"
        prop="modifyName"
        width="140"
        label="最后修改人">
      </el-table-column>
      <el-table-column
        align="center"
        prop="modifyTime"
        label="最后修改时间" width="200">
      </el-table-column>
    </el-table>

    <el-dialog
      title="更新公司明细账"
      :visible.sync="editAreaExpendDialogVisible"
      width="60%"
      @close="closeUpdateCostDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
        <div style="display: flex;justify-content: space-evenly; width: 100%;align-items: center">
          <div style="display: flex;justify-content: flex-start;align-items: center; width: 50%">
            <span style="width: 50px">日期：</span>
            <el-date-picker
              v-model="editAreaExpend.expendDate"
              type="date"
              value-format="yyyy-MM-dd"
              size="mini"
              style="width: 50%"
            >
            </el-date-picker>
          </div>
          <div style="display: flex;justify-content: flex-start;align-items: center;width: 50%">
            <span style="width: 70px">花销类型：</span>
            <el-select v-model="editAreaExpend.expendType" size="mini" style="width: 50%;" placeholder="请选择类型"
                       @change="getExpendType">
              <el-option
                v-for="item in dataTypes"
                :key="item.id"
                :label="item.label"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div style="width: 100%;display: flex;justify-content: space-between;margin-top: 20px">
            <div style="width: 50%">
              <span style="width: 50px">金额：</span>
              <el-input v-model="editAreaExpend.money" onkeyup="value=value.replace(/[^\d.]/g,'')"
                        style="width: 50%" size="mini"></el-input>
            </div>
            <div style="width: 50%">
              <span style="width: 70px">收支类型：</span>
              <el-select v-model="editAreaExpend.szType" size="mini" style="width: 50%;" placeholder="请选择收支类型"
                         @change="getSzType">
                <el-option
                  v-for="item in szTypes"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
        </div>
        <div style="margin-top: 20px">
            <span>摘要：</span>
            <el-input v-model="editAreaExpend.expendTitle"></el-input>
        </div>
        <div style="margin-top: 20px">
            <span>备注：</span>
            <el-input v-model="editAreaExpend.comment"></el-input>
        </div>
      <span class="dialog-footer">
        <el-button size="mini" @click="closeUpdateCostDialog">取 消</el-button>
        <el-button size="mini" @click="updateUserCostMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return{
      orgId:'',
      userId:'',
      userName:'',
      orgLevel:'',
      authorities:'',
      editAreaExpendDialogVisible:false,
      shop:[],
      areaExpends:[],
      dataTypes:[
        {id: 1, label:'广告花销'},
        {id: 2, label:'管理花销'},
      ],
      szTypes:[
        {id: 1, label:'收'},
        {id: 2, label:'支'},
      ],
      orgList:[
        {id: 1, label:'华连生'},
        {id: 992, label:'朋朋修脚'},
        {id: 993, label:'足界文化'},
        {id: 2, label:'大连分公司'},
        {id: 994, label:'大连分公司股东'},
        {id: 995, label:'培训机构'}
      ],
      selectOrgId:'',
      currentPage: 1,
      pageSize: 20,
      currentTotal: 0,
      editAreaExpend:'',
      areaExpendRequest:{
        selectDay:'',
        orgId:'',
        szType:'',
        expendType:'',
        startDate:'',
        endDate:''
      }
    }
  },
  methods:{
    szFormatter(row){
      let value = '';
      if (row.szType === 1){
        value = '收';
      } else {
        value = '支';
      }
      return value;
    },
    getSzType(data){
      this.editAreaExpend.szType = data;
    },
    getExpendType(data){
      this.editAreaExpend.expendType = data;
      this.dataTypes.map((item)=>{
        if (item.id == data){
          this.editAreaExpend.expendTypeName = item.label;
        }
      })
    },
    selectReportDataDay(data){
      if (data == null){
        this.areaExpendRequest.selectDay = '';
      } else {
        this.areaExpendRequest.selectDay = data;
      }
    },
    toNewUserCostPage(){
      this.$router.push("/new/area/expend")
    },
    toEditUserSubsidyPage(){
      this.$router.push('/edit/area/expend')
    },
    async loadAreaExpendList(){
      if(this.orgLevel > 1){
        this.areaExpendRequest.orgId = this.orgId;
      }

      if(this.selectOrgId !== ''){
        this.areaExpendRequest.orgId = this.selectOrgId;
      }
      if (this.areaExpendRequest.selectDay !== ''){
        this.areaExpendRequest.startDate = this.areaExpendRequest.selectDay[0];
        this.areaExpendRequest.endDate = this.areaExpendRequest.selectDay[1];
      } else {
        this.areaExpendRequest.startDate = this.getCurrentDate();
        this.areaExpendRequest.endDate = this.getCurrentDate();
      }
      const {data:res} = await this.$http.post(`/load/gs/mx`, this.areaExpendRequest);
      if (res.code === 200){
        this.areaExpends = res.data;
      }
    },
    async deleteAreaExpend(row){
      const {data:res} = await this.$http.delete(`/gs/mx/${row.id}`);
      if (res.code === 200){
        this.$message.success("操作成功！")
      }
      await this.loadAreaExpendList();
    },
    async getShop(data){
      this.selectOrgId = data;
      if (data !== ''){
        this.areaExpendRequest.orgId = data;
      } else {
        this.areaExpendRequest.orgId = 0;
      }
    },
    getCurrentDate() {
      let date = new Date(new Date().getTime());
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      return year + '-' + month + '-' + day;
    },
    getAreaExpendType(data){
      if (data != ''){
        this.areaExpendRequest.expendType = data;
      } else {
        this.areaExpendRequest.expendType = '';
      }
    },
    showUpdateCostDialog(data){
      this.editAreaExpend = data;
      this.editAreaExpendDialogVisible = true;
    },
    closeUpdateCostDialog(){
      this.editAreaExpendDialogVisible = false;
    },
    async updateUserCostMethod(){
      this.editAreaExpend.modifyName = this.userName;
      this.editAreaExpend.modifier = this.userId;
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.put(`/gs/mx`, this.editAreaExpend);
      if (res.code === 200){
        this.$message.success("操作成功！")
      }
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      await this.loadAreaExpendList();
      this.closeUpdateCostDialog();
    },
  },
  created() {
    this.orgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.userName = window.sessionStorage.getItem("userName");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.orgLevel = window.sessionStorage.getItem('orgLevel');
    this.loadAreaExpendList();
    // if (this.orgLevel == 2){
    //   this.loadShopList();
    //   this.loadAllUser();
    // }
    // if (this.orgLevel == 3){
    //   this.loadUser(this.orgId);
    // }
  }


}
</script>

<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 92vh;
  background-color: #eff3f8;
}
.left_con{
  display: flex;
  justify-content: start;
  height: 100%;
  overflow-y: auto;
  //flex: 1;
  width: auto;
  //border: 1px solid;
  margin: 10px 0;
  //width: 100px;
}
.table_container{
  flex: 1;
  width: 800px;
  height: 100%;
}
.left_inner_con{
  width: 300px;
  height: 98%;
  overflow-y: auto;
  background-color: #F2F6FC;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
.box-card{
  margin: 10px 10px 10px 10px;
  height: 87%;
}
/deep/ .el-dialog{
  background: #fafaff !important;
}

/deep/ .el-dialog__header{
  padding: 15px 20px 10px;
}

/deep/ .el-dialog__body{
  padding: 5px 25px;
  color:#606266;
  font-size:14px;
  word-break:break-all;
}

/deep/ .el-drawer__header{
  z-index: 1;
  position: relative;
  margin-bottom:0;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
.dialog-footer{
  display: flex;
  margin: 10px 10px 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/AreaExpend.vue